import { createSlice } from "@reduxjs/toolkit";

export const detailSlice = createSlice({
    name: 'detail',
    initialState: {
		currentKey: null,
        detail: null
    },
    reducers: {
		setDetail: (state, { payload }) => {
			state.detail = payload.source;
			state.currentKey = payload.key
		},
		resetDetail: (state, props) => {
			state.detail = null;
			state.currentKey = null;
		}
	}
})

export const { setDetail, resetDetail } = detailSlice.actions;
export default detailSlice.reducer;
